import React, { memo } from 'react';
import { getRatingColor } from '../utils/helpers';
import { getAssignmentDisplayNumber, getAssignmentLabel } from '../utils/assignments';
import PlayerNameBadges from './PlayerNameBadges';

function PlayerCard({
  player,
  rateColumns,
  rateMin,
  rateMax,
  assignment,
  onPlayerClick,
  onAddToLineup,
}) {
  const assigned = Boolean(assignment);

  return (
    <div
      className={`player-card ${assigned ? 'assigned' : ''}`}
      onClick={(e) => onPlayerClick(e, player)}
    >
      <div className="player-card-header">
        <div className="player-info">
          <div className="player-name-row">
            <span className="player-name-text">{player.name}</span>
            <PlayerNameBadges player={player} size="large" />
            <button
              type="button"
              className="wishlist-btn lineup-btn"
              onClick={(e) => {
                e.stopPropagation();
                onAddToLineup(player, e);
              }}
            >
              + Lineup
            </button>
          </div>
          <div className="player-age">{player.age ? `Age: ${player.age}` : '\u00A0'}</div>
          <div className="player-meta-line">
            <span>{player.positionDisplay}</span>
            <span className="player-meta-sep">·</span>
            <span>{player.team === 'N/A' ? 'FA' : player.team}</span>
          </div>
          <div className="player-salary">
            ${player.salary ? Number(player.salary).toLocaleString('en-US') : '0'}
          </div>
        </div>
        <div className="player-status">
          {assigned ? (
            <div className="assigned-badge" title={getAssignmentLabel(assignment)}>
              {getAssignmentDisplayNumber(assignment) || 'L1'}
            </div>
          ) : (
            <div className="unassigned-badge" title="Click to assign">
              •
            </div>
          )}
        </div>
      </div>

      <div className="player-ratings">
        {rateColumns.map((rate) => {
          const value = player[rate] || 0;
          const backgroundColor = getRatingColor(value, rateMin, rateMax);
          return (
            <div
              key={rate}
              className="rating-item"
              data-rating={rate}
              style={{ backgroundColor, borderColor: backgroundColor }}
            >
              <span className="rating-label">{rate}</span>
              <span className="rating-value">{value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(PlayerCard);
